export default {
    "APPROVE":{
        title : "Approval Confirmation",				
        confirmButtonText : "Approve",
        cancelButtonText : "Cancel"
    },
    "DELETE":{
        title : "Delete Confirmation",
        confirmButtonText : "Delete",
        cancelButtonText : "Cancel"
    },
    "SAVE":{
        title : "Save Confirmation",
        confirmButtonText : "Save",
        cancelButtonText : "Cancel"
    },
    "DOCUMENTS":{
        title : "Document Confirmation",
        confirmButtonText : "Yes",
        cancelButtonText : "No"
    },
    "SESSION":{
        title : "No internet connection",
        confirmButtonText : "Login",
        cancelButtonText : "Exit"
    },
    "REFRESH":{
        title : "Refresh the page",				
        confirmButtonText : "Refresh",
        cancelButtonText : "Cancel"
    },
    "DEFAULT":{
        title : "Confirmation",
        confirmButtonText : "Ok",
        cancelButtonText : "Cancel"
    },
    

}